import { render, staticRenderFns } from "./StartupByShopBtn.vue?vue&type=template&id=07bbbac8&scoped=true"
import script from "./StartupByShopBtn.vue?vue&type=script&lang=ts"
export * from "./StartupByShopBtn.vue?vue&type=script&lang=ts"
import style0 from "./StartupByShopBtn.vue?vue&type=style&index=0&id=07bbbac8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07bbbac8",
  null
  
)

export default component.exports